import React from 'react';
import "./sidebar.scss";
import DashboardIcon from '@mui/icons-material/Dashboard';
import PermIdentityIcon from '@mui/icons-material/PermIdentity';
import InventoryIcon from '@mui/icons-material/Inventory';
import CategoryIcon from '@mui/icons-material/Category';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import InsertChartIcon from '@mui/icons-material/InsertChart';
import NotificationsNoneIcon from '@mui/icons-material/NotificationsNone';
import SettingsSystemDaydreamOutlinedIcon from '@mui/icons-material/SettingsSystemDaydreamOutlined';
import PsychologyOutlinedIcon from '@mui/icons-material/PsychologyOutlined';
import SettingsApplicationsIcon from '@mui/icons-material/SettingsApplications';
import AccountCircleOutlinedIcon from '@mui/icons-material/AccountCircleOutlined';
import ExitToAppOutlinedIcon from '@mui/icons-material/ExitToAppOutlined';
import {Link} from "react-router-dom";
import { useContext } from 'react';
import { DarkModeContext } from '../context/darkModeContext';


export const Sidebar = () => {
   const {dispatch} = useContext (DarkModeContext);

  return (
    <div className='sidebar'>
        <div className="top">
          <Link to="/" style={{textDecoration:"none"}}>
         <span className="logo">Taniadmin</span>
          </Link> 
        </div>
        <hr />
        <div className="center">
         <ul>
            <p className="title">MAIN</p>
             <li>
                <DashboardIcon className="icon"/>
                <span>Dashboard</span> 
             </li>
           

             <p className="title">LISTS  </p>
             <Link to="/users" style={{textDecoration:"none"}}>
             <li>
                <PermIdentityIcon className="icon"/>
                <span>Users</span> 
             </li>
             </Link>
             
             <Link to="/products" style={{textDecoration:"none" }}>
             <li>
                <InventoryIcon className="icon"/>
                <span>Products</span> 
             </li>
             </Link>

             <li>
                <CategoryIcon className="icon"/>
                <span>Orders</span> 
             </li>

             <li>
                 <LocalShippingIcon className="icon"/>
                <span>Delivery</span> 
             </li>
            

             <p className="title">USEFUL</p>

             <li>
                <InsertChartIcon className="icon"/>
                <span>Stats</span> 
             </li>

             <li>
                 <NotificationsNoneIcon className="icon"/>
                <span>Notifications</span> 
             </li>
            

             <p className="title">SERVICES</p>

             <li>
                <SettingsSystemDaydreamOutlinedIcon className="icon"/>
                <span>System Health</span> 
             </li>

             <li>
                <PsychologyOutlinedIcon className="icon"/>
                <span>Logs</span> 
             </li>

             <li>
                <SettingsApplicationsIcon className="icon"/>
                <span>Settings</span> 
             </li>
           

             <p className="title">USER</p>
             <li>
                <AccountCircleOutlinedIcon className="icon"/>
                <span>Profile</span> 
             </li>

             <li>
                <ExitToAppOutlinedIcon className="icon"/>
                <span>Log out</span> 
             </li>
         
         </ul>
      </div>
        <div className="bottom">
           <div className="coloroption" 
           onClick={()=> dispatch({type: "LIGHT"})}>
          </div> 
           
           <div className="coloroption"
            onClick={()=>dispatch({type:"DARK"})}>
          </div> 
          
        </div>
    </div>
  )
}
